<div class="term-selector">
  <span *ngIf="label" class="term-selector__label">{{ label }}</span>
  <div class="term-selector__chips" role="tablist">
    <ds-term-chip
      *ngFor="let term of terms; trackBy: trackByTerm"
      class="term-selector__chip"
      role="tab"
      [attr.aria-selected]="term === selectedTerm"
      [label]="chipLabel(term)"
      [amount]="priceFor(term)"
      [showPrice]="showPrice"
      [selected]="term === selectedTerm"
      [disabled]="disabled"
      (chipClick)="selectTerm(term)"
    ></ds-term-chip>
  </div>
</div>
